import { AxiosError, AxiosResponse } from 'axios';
import {
    FERTILIZER_PRODUCTS_SET,
    FERTILIZER_PRODUCT_CREATE_FAILED,
    FERTILIZER_PRODUCT_CREATE_REQUESTED,
    FERTILIZER_PRODUCT_CREATE_SUCCEEDED,
    FERTILIZER_PRODUCT_DELETE_FAILED,
    FERTILIZER_PRODUCT_DELETE_REQUESTED,
    FERTILIZER_PRODUCT_DELETE_SUCCEEDED,
    FERTILIZER_PRODUCT_SET,
    FERTILIZER_PRODUCT_UPDATE_FAILED,
    FERTILIZER_PRODUCT_UPDATE_REQUESTED,
    FERTILIZER_PRODUCT_UPDATE_SUCCEEDED
} from './constants';
import {
    FailedCreateFertilizerProductAction,
    FailedDeleteFertilizerProductAction,
    FailedUpdateFertilizerProductAction,
    FertilizerProduct,
    FertilizerProductId,
    FertilizerProductsState,
    FertilizerProductUuid,
    PatchFertilizerProductPayload,
    PostFertilizerProductPayload,
    RequestedCreateFertilizerProductAction,
    RequestedDeleteFertilizerProductAction,
    RequestedUpdateFertilizerProductAction,
    SetFertilizerProductAction,
    SetFertilizerProductsAction,
    SucceededCreateFertilizerProductAction,
    SucceededDeleteFertilizerProductAction,
    SucceededUpdateFertilizerProductAction
} from './types';

export function setFertilizerProducts(
    products: FertilizerProductsState
): SetFertilizerProductsAction {
    return {
        type: FERTILIZER_PRODUCTS_SET,
        payload: products
    };
}

export function setFertilizerProduct(
    product: FertilizerProduct
): SetFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_SET,
        payload: { [product.uuid]: product }
    };
}

export function requestedCreateFertilizerProduct(
    data: PostFertilizerProductPayload
): RequestedCreateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_CREATE_REQUESTED,
        data,
        meta: {
            logentries: true
        }
    };
}

export function succeededCreateFertilizerProduct(
    response: AxiosResponse
): SucceededCreateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateFertilizerProduct(
    error: AxiosError
): FailedCreateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestedUpdateFertilizerProduct(
    id: FertilizerProductId,
    product: PatchFertilizerProductPayload
): RequestedUpdateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_UPDATE_REQUESTED,
        payload: {
            id,
            product
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededUpdateFertilizerProduct(
    response: AxiosResponse
): SucceededUpdateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateFertilizerProduct(
    error: AxiosError
): FailedUpdateFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestedDeleteFertilizerProduct(
    product: FertilizerProduct
): RequestedDeleteFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_DELETE_REQUESTED,
        payload: product,
        meta: {
            logentries: true
        }
    };
}

export function succeededDeleteFertilizerProduct(
    productUuid: FertilizerProductUuid
): SucceededDeleteFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_DELETE_SUCCEEDED,
        payload: productUuid
    };
}

export function failedDeleteFertilizerProduct(
    error: AxiosError
): FailedDeleteFertilizerProductAction {
    return {
        type: FERTILIZER_PRODUCT_DELETE_FAILED,
        payload: error,
        error: true
    };
}
